import { $t } from '../../composables/i18n'
import { Codebook } from '../Codebook'
import { SaleTypeId } from '../sale-type/SaleType'

export enum FeeTransferProductId {
  PMS = 'pms',
  CHM = 'chm',
  RESERVATIONS_PLUS = 'reservations_plus',
  AGENCY = 'agency',
  HOUSEKEEPING = 'housekeeping',
  SCAN_ID = 'scan_id',
  ALFRED = 'alfred',
  PAY = 'pay',
  API = 'api',
  AI_CHATBOT = 'ai_chatbot',
  WEB = 'web',
}

export class FeeTransferProduct extends Codebook<FeeTransferProductId> {
  static readonly PMS = new FeeTransferProduct(FeeTransferProductId.PMS, () => $t('PMS'), [
    SaleTypeId.PRO,
    SaleTypeId.LITE,
    SaleTypeId.CONNECT,
    SaleTypeId.PMS,
  ])

  static readonly CHM = new FeeTransferProduct(FeeTransferProductId.CHM, () => $t('CHM'), [
    SaleTypeId.CHM,
  ])

  static readonly RESERVATIONS_PLUS = new FeeTransferProduct(
    FeeTransferProductId.RESERVATIONS_PLUS,
    () => $t('Reservations+'),
    [SaleTypeId.IBE],
  )

  static readonly AGENCY = new FeeTransferProduct(
    FeeTransferProductId.AGENCY,
    () => $t('Agency / owner'),
    [SaleTypeId.AGENCY],
  )

  static readonly HOUSEKEEPING = new FeeTransferProduct(
    FeeTransferProductId.HOUSEKEEPING,
    () => $t('Housekeeping app'),
    [SaleTypeId.HOUSEKEEPING_APP],
  )

  static readonly SCAN_ID = new FeeTransferProduct(
    FeeTransferProductId.SCAN_ID,
    () => $t('ScanID app'),
    [SaleTypeId.SCANID_APP],
  )

  static readonly ALFRED = new FeeTransferProduct(FeeTransferProductId.ALFRED, () => $t('Alfred'), [
    SaleTypeId.ALFRED,
    SaleTypeId.ALFRED_GROUP,
    SaleTypeId.ALFRED_CHECK_IN,
    SaleTypeId.ALFRED_SERVICE,
    SaleTypeId.ALFRED_CLEANING,
    SaleTypeId.ALFRED_SMS_FEE,
    SaleTypeId.ALFRED_SMS_INTERNATIONAL,
    SaleTypeId.ALFRED_DOOR_LOCK_OR_PIN,
  ])

  static readonly PAY = new FeeTransferProduct(FeeTransferProductId.PAY, () => $t('PAY'), [
    SaleTypeId.CONNECTOR_TO_PAYMENT_TERMINAL,
    SaleTypeId.CONNECTOR_TO_PAYMENT_GATEWAY,
    SaleTypeId.CONNECTOR_TO_PAYMENT_TERMINAL_AND_GATEWAY,
    SaleTypeId.CONNECTOR_PAYMENTS,
  ])

  static readonly API = new FeeTransferProduct(FeeTransferProductId.API, () => $t('API'), [
    SaleTypeId.CONNECTOR_TO_3RD_PARTY_CHM_OR_IBE,
    SaleTypeId.CONNECTOR_TO_ALL_OTHER_SWS,
  ])

  static readonly AI_CHATBOT = new FeeTransferProduct(
    FeeTransferProductId.AI_CHATBOT,
    () => $t('AI chatbot'),
    [SaleTypeId.AI_CHATBOT],
  )

  static readonly WEB = new FeeTransferProduct(FeeTransferProductId.WEB, () => $t('Website'), [
    SaleTypeId.WEBSITE,
    SaleTypeId.TEMPLATE,
    SaleTypeId.INDIVIDUAL,
  ])

  private constructor(
    id: FeeTransferProductId,
    public readonly name: () => string,
    public readonly saleTypeIds: SaleTypeId[],
  ) {
    super(id)
  }

  static forSaleType(saleTypeId: SaleTypeId): FeeTransferProduct | null {
    return (
      FeeTransferProduct.all().find((product) => product.saleTypeIds.includes(saleTypeId)) ?? null
    )
  }
}
